import { render } from "./wishlist-button.vue?vue&type=template&id=0c4fe31e"
import script from "./wishlist-button.vue?vue&type=script&lang=js"
export * from "./wishlist-button.vue?vue&type=script&lang=js"

import "./wishlist-button.vue?vue&type=style&index=0&id=0c4fe31e&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__